export const isSameInstitusjon = (pathInst, sessionInst) => {
    return (sessionInst && sessionInst.akronym) === (pathInst && pathInst.akronym);
};